import SideBar from "../components/SidebarPlugin";
import GlobalComponents from "./globalComponents";

export default {
    install(Vue) {
        Vue.use(GlobalComponents);
        Vue.use(SideBar);
    }
}



// WEBPACK FOOTER //
// ./src/plugins/paperDashboard.js